import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';

import { Api } from '../../providers/api/api';
import { IPTV } from '../../providers/iptv/iptv';
import { User } from '../../providers/user/user';
import { Utils } from '../../providers/utils/utils';
import { Fav }   from '../../providers/fav/fav';
import { FavApp }   from '../../providers/favapp/favapp';
import { TabsMain }  from '../tabsmain/tabsmain';

/*
*
*  Channel Page
*
*/
@Component({
  selector: 'application',
  templateUrl: 'application.html'
})
export class Application {

    public applications : any = [];
    public applicationsChecked : any = [];

    constructor( 
        private navCtrl: NavController, 
        public utils: Utils,
        public events: Events, 
        public IPTV: IPTV,
        private api : Api,
        public user: User,
        public fav: Fav,
        public favApp: FavApp
    ) {

        this.events.subscribe('app:refresh', (params : any = {}) => { 
            if (this.navCtrl.canGoBack()) 
                this.navCtrl.setRoot(TabsMain);{
            }
        });

        this.events.subscribe('favoriteapp:refresh', (params : any = {}) => { 
            this.fetch(true);
        });

    }

    ionViewWillEnter(){
        this.navCtrl.swipeBackEnabled = true;
    }
      
    ionViewDidLeave() {
        this.navCtrl.swipeBackEnabled = true;
    }
    
    ionViewDidLoad() {  
        this.fetch();
    }

    navPop() {
        this.navCtrl.pop();
    }

    doRefresh(refresher) {

        this.getApplication(true).then((data: any = []) => {
            this.applications = data;
            this.prepareApplication();
            
            let that = this;
            this.favApp.getFavoritesApp(true).then((data2 : any = []) => {

                for(let app of that.applications) {
                    app.fav = false;
                    for(let fav of data2) {
                        if (fav.id == app.id) {
                            app.fav = true;
                        } 
                    }
                }

                refresher.complete();
            }, (err) => {
                refresher.complete();
                this.utils.error(err);
            });

        }, (err) => {
            refresher.complete();
            this.utils.error(err);
        });

    }


    fetch(noLoad:boolean=false, writeCache:boolean=false) {

        if (!noLoad) this.utils.load();

        this.getApplication(writeCache).then((data: any = []) => {
            this.applications = data;
            this.prepareApplication();

            let that = this;
            this.favApp.getFavoritesApp(writeCache).then((data2 : any = []) => {

                for(let app of that.applications) {
                    app.fav = false;
                    for(let fav of data2) {
                        if (fav.id == app.id) {
                            app.fav = true;
                        } 
                    }
                }

                if (!noLoad) this.utils.unload();
            }, (err) => {
                if (!noLoad) this.utils.unload();
                this.utils.error(err);
            });
            
        }, (err) => {
            if (!noLoad) this.utils.unload();
            this.utils.error(err);
        });
    }

    getApplication(writeCache:boolean=false) {
        return new Promise((resolve, reject) => {
            this.api.getCached('/iptv/application/'+this.IPTV.box.id_box, { writeCache:writeCache }).subscribe((response:any)=>{
                resolve(response.result.result);
            },(err) => {
                reject(this.api.reject(err));
            });
       });
    }

    prepareApplication() {
        this.applicationsChecked = [];

        for(let _app of this.applications) {
            this.utils.checkApplication(_app).then((response) => {
                this.applicationsChecked.push(_app);
            }, (err) => {});
        }
    }

}






// WEBPACK FOOTER //
// ./src/pages/application/application.ts